<template>
  <div v-if="!progress">Loading...</div>
  <div v-else>
    <div class="is-hidden-desktop has-text-centered">
      <router-link to="/library">
        Back to library
      </router-link>
    </div>
    <br />
    <p class="has-text-centered is-size-4" v-if="progress.studentEmail">
      Progress report for <b>{{ progress.studentEmail }}</b>
    </p>
    <DisciplineSection :key="key" :targetHistories="progress.targetHistories" />
    <TargetsSection
      v-if="progress.targetHistories.length > 0"
      :key="key * 100"
      :targetHistories="progress.targetHistories"
    />
    <DictationSection
      v-if="progress.dictationRecords.length > 0"
      :key="key * 311"
      :dictationRecords="progress.dictationRecords"
    />
    <RecordingsSection
      v-if="progress.recordings"
      :key="key * 755"
      :recordings="progress.recordings"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dataService from "../services/dataService";
import DisciplineSection from "../components/Progress/DisciplineSection";
import TargetsSection from "../components/Progress/TargetsSection";
import DictationSection from "../components/Progress/DictationSection";
import RecordingsSection from "../components/Progress/RecordingsSection";

export default {
  name: "Progress",
  components: {
    TargetsSection,
    DisciplineSection,
    DictationSection,
    RecordingsSection
  },
  data() {
    return {
      progress: undefined,
      key: 1
    };
  },
  methods: {
    ...mapActions(["fetchBooksAction"]),
    async fetchProgress() {
      this.progress = this.studentGuid
        ? await dataService.getStudentProgress(this.studentGuid)
        : await dataService.getProgress();
    }
  },
  computed: {
    studentGuid() {
      return this.$route.params.studentGuid;
    }
  },
  async created() {
    // Fetching books here because child components will need to get book names by id
    await this.fetchBooksAction();
    await this.fetchProgress();
  },
  watch: {
    async $route() {
      await this.fetchProgress();
      this.key += 1;
    }
  }
};
</script>

<style lang="scss" scoped></style>
